<script setup lang="ts"></script>

<template>
  <span class="pl-1 pr-2 h-[30px] flex items-center justify-center mr-1">
    <BaseIconWand size="14" class="text-primary-default" />
  </span>
</template>

<style scoped></style>
